import React, { Component } from 'react';
import { Row } from 'reactstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import LoadingIcon from 'mdi-react/LoadingIcon';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import TableRow from 'components/tables/tableRow';
import * as Moment from 'moment';
import Switch from 'components/forms/Switch';

import { updateSubscription, getSubscriptions } from 'redux/actions/subscriptionActions';
import { getSubscriptionTypes } from 'redux/actions/subscriptionTypeActions';
import { getSubscriptionProducts } from 'redux/actions/subscriptionProductActions';
import SubscriptionCreate from './SubscriptionCreate';
import SubscriptionUpdate from './SubscriptionUpdate';


class SubscriptionsTab extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    getSubscriptions: PropTypes.func.isRequired,
    updateSubscription: PropTypes.func.isRequired,
    getSubscriptionTypes: PropTypes.func.isRequired,
    getSubscriptionProducts: PropTypes.func.isRequired,
    subscriptions: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
  };

  componentDidMount() {
    this.props.getSubscriptions(this.props.match.params.id);
    this.props.getSubscriptionTypes();
    this.props.getSubscriptionProducts();
  }

  handleStatusChange = supscription => (e) => {
    this.props.updateSubscription(supscription.id, { status: e.target.checked }, true);
  }

  render() {
    const isSubscriptionsLoading = this.props.subscriptions.loading;

    if (isSubscriptionsLoading) {
      return (
        <div className="loader"><LoadingIcon /></div>
      );
    }

    return (
      <div>
        <div className="text-right">
          <SubscriptionCreate accountId={this.props.match.params.id} />
        </div>
        <Row>
          {(!this.props.subscriptions.loading && !this.props.subscriptions.results.length >= 1) ? (
            <h5 className="text-center">No subscriptions added yet</h5>
          ) : (
            <Table className="volt-table">
              <TableHead>
                <TableRow>
                  <TableCell>Subscription GW id</TableCell>
                  <TableCell>Plan type</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created date</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {!this.props.subscriptions.loading &&
                this.props.subscriptions.results.map(subscription => (
                  <TableRow key={subscription.id}>
                    <TableCell>{subscription.gateway_uid}</TableCell>
                    <TableCell>{subscription.subscription_type_name}</TableCell>
                    <TableCell>
                      {/* eslint-disable jsx-a11y/label-has-for */}
                      <label>
                        <Switch
                          onChange={this.handleStatusChange(subscription)}
                          checked={subscription.status}
                        />
                      </label>
                    </TableCell>
                    <TableCell>{Moment(subscription.created_date).format('MM/DD/YYYY')}</TableCell>
                    <TableCell>
                      <SubscriptionUpdate
                        accountId={this.props.match.params.id}
                        initialValues={{
                          subscriptionId: subscription.id,
                          gateway_uid: subscription.gateway_uid,
                          subscription_type: subscription.subscription_type,
                          products: subscription.products,
                        }}
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                ))
                }
              </TableBody>
            </Table>
          )}
        </Row>

      </div>
    );
  }
}


export default compose(
  withNamespaces('common'),
  connect(
    state => ({
      subscriptions: state.subscriptions,
    }),
    {
      getSubscriptions,
      updateSubscription,
      getSubscriptionTypes,
      getSubscriptionProducts,
    },
  ),
)(SubscriptionsTab);
